import React from "react";
import { ActionButton } from "./ActionButton";

export function CancelButton({
  text = "Cancel",
  label,
  children,
  onClick,
  onCancel,
  variant = "outline-secondary",
  ...restProps
}) {
  const displayText =
    label || (text !== undefined ? text : children) || "Cancel";
  const handleClick = onClick || onCancel;

  return (
    <ActionButton
      text={displayText}
      variant={variant}
      onClick={handleClick}
      {...restProps}
    />
  );
}

export default CancelButton;
